import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Classes = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddClass = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditClass = () => {
  return (
    
      
        <Edit />
      
    
  );
};
